import {
  File,
  FileArchive,
  FileImage,
  FileSpreadsheet,
  FileText,
  Folder,
  type LucideIcon,
} from 'lucide-react';

export function getFileTypeIcon(fileType: string | null | undefined): LucideIcon {
  const normalizedType = fileType?.toLowerCase().replace(/^\./, '');

  switch (normalizedType) {
    case 'pdf':
    case 'doc':
    case 'docx':
    case 'ppt':
    case 'pptx':
      return FileText;
    case 'xls':
    case 'xlsx':
      return FileSpreadsheet;
    case 'jpg':
    case 'jpeg':
    case 'png':
      return FileImage;
    case 'zip':
      return FileArchive;
    case 'folder':
      return Folder;
    default:
      return File;
  }
}
